import { useEffect, useState, useCallback } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
//import { getInstancesWithAdd,getInstancesWithAddglobal } from '../accounts/troubleshoot/request/request';
import ModalSwal from '../../permisoDenegado/Modalswal';
import Spinner from '../Spinner/Spinner';
import axios from 'axios';
import Swal from 'sweetalert2';
import { getInstances } from '../Dashboard/requests/request';
import { getInstancesGlobales } from '../Dashboard/requests/request';
import { useAuth } from '../../auth';
import Modal1 from './component/modalIP';
import Modal2 from './component/modal2IP';
import { useAppDispatch } from '../../../../redux/hooks';
import "./estilos.css"
import { SetInstance } from '../../../../redux/feature/InstanceSlice';
import { SetvRF } from '../../../../redux/feature/VrfSlice';
import { SetConnector } from '../../../../redux/feature/ConnectorSlice';

const API_URL = process.env.REACT_APP_API_URL


type policy = {
  id: any
  local: string,
  remote: string,
  security: string

}
type vrf = {
  vendor: string,
  vrf: string
  subscription: (string)
}
type connector = {
  id: string,
  name: string
}

export default function AddIPSecSegment(props: any) {
  const { currentUser } = useAuth()

  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const Instance = useAppSelector(state => state.InstanceSlice.id);
  const VRF = useAppSelector(state => state.VrfSlice.id)
  const connector = useAppSelector(state => state.ConnectorSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)
  const dispatch = useAppDispatch();


  const [Instancia, setInstancia] = useState([{
    id: 0,
    name: " ",
    type: ''

  }])

  //const[Busqueda,setBusqueda]= useState("")
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  const [Datos, setDatos] = useState<policy[]>([])
  const [listvrf, setlistvrff] = useState<vrf[]>([])


  ////////////////////////////////////////////////////////////
  //const [vrfselect,setselectvrf]= useState<any>()
  const [action, setaction] = useState<any>()
  const [prefix, setprefix] = useState<any>()
  const [greater, setgreater] = useState<number>(0)
  const [less, setless] = useState<number>(0)
  //const[connector,setconnector]=useState<any>()






  /*const vrfseleccionada = (e:any)=>{
    setselectvrf(e.target.value)
  }*/



  /*const connectorseleccionado= (e:any)=>{
  setconnector(e.target.value)
  }*/

  /**********************Llamada a axios y parse de data**********************/

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.IPSEC.List')) {
          if (tenant === 0) {
            const instancias = await getInstances(Id, 'Ctx.IPSEC.List', Type, nameregion);
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            }
            else {
              setInstancia(instancias.data)
              if (instancias.data.length > 0) {
                dispatch(SetInstance(Number(instancias.data[0].id)));
              }


            }
          }
          else {
            const instancias = await getInstancesGlobales(Id, tenant, 'Ctx.IPSEC.List', Type, nameregion);
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            }
            else {

              setInstancia(instancias.data)
              if (instancias.data.length > 0) {
                dispatch(SetInstance(Number(instancias.data[0].id)));
              }

            }
          }

          if (Id !== 0 && Id !== -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.IPSEC.List')) {
            if (tenant === 0) {
              const instancias = await getInstances(Id, 'Ctx.IPSEC.List');
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              }
              else {
                setInstancia(instancias.data)
                if (instancias.data.length > 0) {
                  dispatch(SetInstance(Number(instancias.data[0].id)));
                }


              }
            }
            else {
              const instancias = await getInstancesGlobales(Id, tenant, 'Ctx.IPSEC.List');
              if (instancias.data && instancias.data.error === 'id suscription invalido') {
                setInstancia([])
              }
              else {

                setInstancia(instancias.data)
                if (instancias.data.length > 0) {
                  dispatch(SetInstance(Number(instancias.data[0].id)));
                }

              }
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [nameregion]
  )
  /////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && Instance !== '') {

          const body =
          {
            instanceId: Number(Instance),
            suscriptionId: Id
          }
          if (tenant !== 0) {
            await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
              .then(res => {
                setlistvrff(res.data)
              })
          }

          else if (tenant === 0) {
            await axios.post(API_URL + '/v1/listVrf', body)
              .then(res => {
                setlistvrff(res.data)
              })
          }

        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Instance, Id])

  const [listConnector, setlisConnector] = useState<connector[]>([])


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && Instance !== '' && VRF !== undefined && VRF !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Instance) === x.id) {
              type = x.type
            }
          }
          const vrf = listvrf[Number(VRF)]

          const body =
          {
            type: type,
            vrf: vrf
          }
          if (tenant !== 0) {
            await axios.get(API_URL + '/v1/VPN/instances/' + Instance + '/list_connector?tenantId=' + tenant)
              .then(res => {
                setlisConnector(res.data)
              })
          }

          else if (tenant === 0) {
            await axios.get(API_URL + '/v1/VPN/instances/' + Instance + '/list_connector')
              .then(res => {
                setlisConnector(res.data)
              })
          }

        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [VRF])
  /**********************************Se obtienen datos para la ipsec List******************************************/
  const [loading, setLoading] = useState(false)


  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (Id !== -1 && Type !== 'CloudGlobal' && Id !== 0 && currentUser?.ListPermiso?.includes('Ctx.IPSEC.List')) {
      try {
        if (Instance === '') {
          Swal.fire(
            'Oooops!',
            'Please select an Instance',
            'warning',
          )
        }
        else if (VRF === '') {
          Swal.fire(
            'Oooops!',
            'Please select a VRF',
            'warning',

          )
        }
        else if (connector === '') {
          Swal.fire(
            'Oooops!',
            'Please select a Connector',
            'warning',

          )
        }
        else if (Instance !== '' && VRF !== '' && connector !== '') {
          setLoading(true)
          let type
          for (const x of Instancia) {
            if (Number(Instance) === x.id) {
              type = x.type
            }
          }

          const vrf = listvrf[Number(VRF)]
          const body = {
            type: type,
            vrf: vrf,
          }

          if (tenant !== 0) {
            await axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/list_phase_two/' + connector + '?tenantId=' + tenant, body)
              .then(res => {
                if (res.data.error) {
                  Swal.fire({
                    icon: 'error',
                    title: 'Cannot connect to the device.',
                  })
                }
                else {
                  setDatos(res.data)
                }
              })
          }

          else if (tenant == 0) {
            await axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/list_phase_two/' + connector, body)
              .then(res => {
                if (res.data.error) {
                  Swal.fire({
                    icon: 'error',
                    title: 'Cannot connect to the device.',
                  })
                }
                else {
                  setDatos(res.data)
                }
              })
          }
        }
      }
      catch (error: any) {
        console.log(error)

      }
      finally {
        setLoading(false);
      }

    }
  }


  /*********************************************SE REALIZA DELETE para prefix list ********************** */
  const [del, setdel] = useState(false)

  function deletepolicy(id: any) {
    if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && Instance !== '' && connector !== '' && prefix != '') {
      try {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: "Are you sure?",
          text: "Once deleted, you will not be able to recover this IPSec Segment!",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })
          .then((result) => {

            if (result.isConfirmed) {
              setdel(true)
              const elemento = document.getElementById("delete" + id)

              if (elemento != null) {
                elemento.innerText = 'Eliminating...'
              }



              const vrf = listvrf[Number(VRF)]
              const body = {
                vrf: vrf,
                policy: {
                  name: id,
                }
              }

              if (tenant === 0) {
                axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/delete_one_phase_two/' + connector, body).then(res => {
                  setDatos(res.data)
                  Swal.fire(
                    'Deleted!',
                    'Your IPSec Segment has been deleted.',
                    'success'
                  );
                  if (elemento != null) {
                    elemento.innerText = 'Delete'
                  }
                  setdel(false)
                })

              }
              else if (tenant !== 0) {
                axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/delete_one_phase_two/' + connector + '?tenantId=' + tenant, body).then(res => {
                  setDatos(res.data)
                  Swal.fire(
                    'Deleted!',
                    'Your IPSec Segment has been deleted.',
                    'success'
                  );
                  if (elemento != null) {
                    elemento.innerText = 'Delete'
                  }
                  setdel(false)
                })

              }

            } else {
              Swal.fire({ title: "Your BGP Segment is safe!", icon: "success" });
            }
          });
      }
      catch (error: any) {
        console.log(error)

      }

    }
  }


  ///////////////////////////////////////////////////GLOBAL////////////////////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && currentUser?.ListPermiso?.includes('Ctx.IPSEC.List')) {
          if (tenant === 0) {
            const instancias = await getInstances(-1, 'Ctx.IPSEC.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            }
            else {
              setInstancia(instancias.data)
              if (instancias.data.length > 0) {
                dispatch(SetInstance(Number(instancias.data[0].id)));
              }
            }
          }
          else {
            const instancias = await getInstancesGlobales(-1, tenant, 'Ctx.IPSEC.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            }
            else {
              setInstancia(instancias.data)
              if (instancias.data.length > 0) {
                dispatch(SetInstance(Number(instancias.data[0].id)));
              }
            }
          }

        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id, Type]
  )
  /////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Type === 'CloudGlobal' && Instance !== '') {

          const body =
          {
            instanceId: Number(Instance),
            suscriptionId: '-1'
          }
          await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
            .then(res => {
              setlistvrff(res.data)
            })

        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Instance, Id, Type])
  ////////////////////////////
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Instance !== '' && VRF !== undefined && VRF !== '' && Type === 'CloudGlobal') {
          let type
          for (const x of Instancia) {
            if (Number(Instance) === x.id) {
              type = x.type
            }
          }
          const vrf = listvrf[Number(VRF)]

          const body =
          {
            type: type,
            vrf: vrf
          }
          await axios.get(API_URL + '/v1/VPN/instances/' + Instance + '/list_connector?tenantId=' + tenant)
            .then(res => {
              setlisConnector(res.data)
            })

        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Id, VRF])

  /**********************************Se obtienen datos para la prefixlist******************************************/
  const handleSubmitGlobal = async (e: any) => {
    //e.preventDefault();
    if (Type == 'CloudGlobal') {
      try {
        if (Instance === '') {
          Swal.fire(
            'Oooops!',
            'Please select an Instance',
            'warning',
          )
        }
        else if (VRF === '') {
          Swal.fire(
            'Oooops!',
            'Please select a VRF',
            'warning',

          )
        }
        else if (connector === '') {
          Swal.fire(
            'Oooops!',
            'Please select a Connector',
            'warning',

          )
        }
        else if (Instance !== '' && VRF !== '' && connector !== '') {
          setLoading(true)
          let type
          for (const x of Instancia) {
            if (Number(Instance) === x.id) {
              type = x.type
            }
          }

          const vrf = listvrf[Number(VRF)]
          const body = {
            type: type,
            vrf: vrf,
          }

          if (tenant === 0) {
            await axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/list_phase_two/' + connector, body)
              .then(res => {
                if (res.data.error) {
                  Swal.fire({
                    icon: 'error',
                    title: 'Cannot connect to the device.',
                  })
                }
                else {
                  setDatos(res.data)
                }
              })
          }
          else if (tenant !== 0) {
            await axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/list_phase_two/' + connector + '?tenantId=' + tenant, body)
              .then(res => {
                if (res.data.error) {
                  Swal.fire({
                    icon: 'error',
                    title: 'Cannot connect to the device.',
                  })
                }
                else {
                  setDatos(res.data)
                }
              })
          }

        }

      }
      catch (error: any) {
        console.log(error)

      }
      finally {
        setLoading(false);
      }

    }
  }



  /*********************************************SE REALIZA DELETE para prefix list ********************** */
  function DeleteGlobal(id: any) {
    if (Instance !== '' && connector !== '' && prefix != '' && Type == 'CloudGlobal') {
      try {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: "Are you sure?",
          text: "Once deleted, you will not be able to recover this IPSec Segment!",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })
          .then((result) => {

            if (result.isConfirmed) {
              setdel(true)
              const elemento = document.getElementById("delete" + id)

              if (elemento != null) {
                elemento.innerText = 'Eliminating...'
              }



              const vrf = listvrf[Number(VRF)]
              const body = {
                vrf: vrf,
                policy: {
                  name: id,
                }
              }

              if (tenant === 0) {
                axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/delete_one_phase_two/' + connector, body).then(res => {
                  setDatos(res.data)
                  Swal.fire(
                    'Deleted!',
                    'Your BGP Segment has been deleted.',
                    'success'
                  );
                  if (elemento != null) {
                    elemento.innerText = 'Delete'
                  }
                  setdel(false)
                })

              }
              else if (tenant !== 0) {
                axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/delete_one_phase_two/' + connector + '?tenantId=' + tenant, body).then(res => {
                  setDatos(res.data)
                  Swal.fire(
                    'Deleted!',
                    'Your BGP Segment has been deleted.',
                    'success'
                  );
                  if (elemento != null) {
                    elemento.innerText = 'Delete'
                  }
                  setdel(false)
                })

              }

            } else {
              Swal.fire({ title: "Your BGP Segment is safe!", icon: "success" });
            }
          });
      }
      catch (error: any) {
        console.log(error)

      }

    }
  }





  useEffect(() => {
    if (Instance) {
      setDatos([])
      setSelectedItems([])
    }
  }, [Instance, VRF])

  useEffect(() => {
    if (Instance) {
      dispatch(SetvRF(''));
      dispatch(SetConnector(''));

      setgreater(0)
      setless(0)
      setaction('')
    }
  }, [Instance])

  useEffect(() => {
    if (VRF) {
      dispatch(SetConnector(''));
      setSelectedItems([])
      setgreater(0)
      setless(0)
      setaction('')
    }
  }, [VRF])
  /******************************check box **************/
  // const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions)
  // const MostrarModal = !(ListaPermisosTenant.includes('Ctx.IPSEC.List') || ListaPermisosTenant.includes('Ctx.IPSEC.Add') || ListaPermisosTenant.includes('Ctx.IPSEC.Delete'))
  /*********************************Modales */
  const [modal1Visible, setModal1Visible] = useState(false);
  const [modal2Visible, setModal2Visible] = useState(false);
  const handleModal1Click = () => {
    setModal1Visible(true);
  };

  const handleModal2Click = () => {
    setModal2Visible(true);
  };

  const handleCloseModal1 = () => {
    setModal1Visible(false);
  };

  const handleCloseModal2 = () => {
    setModal2Visible(false);
  }

  // Función para manejar la selección de elementos
  const toggleSelect = (security: any) => {
    if (selectedItems.includes(security)) {
      setSelectedItems(selectedItems.filter(item => item !== security));
    } else {
      setSelectedItems([...selectedItems, security]);
    }
  };

  // Función para eliminar elementos seleccionados
  const [swalInput, setSwalInput] = useState('');

  const deleteSelected = () => {
    // Lógica para eliminar elementos seleccionados
    Swal.fire({
      icon: 'warning',
      title: "Are you sure you want to delete the following policies?",
      html: `<pre style="text-align: center; margin: auto;">${selectedItems.map((data: any) => `Policy: ${data}<br/>`).join('')}</pre>`,
      input: 'text',
      inputPlaceholder: 'Enter "confirm" to continue...',
      inputValue: swalInput,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete!',
      preConfirm: (value) => {
        if (!value.toLowerCase().includes('confirm')) {
          Swal.showValidationMessage('The input must contain the word "confirm"');
        } else {
          setSwalInput(value);
        }
      },
    })
      .then((result) => {
        if (result.isConfirmed) {
          setSwalInput('');
          setdel(true)
          const elemento = document.getElementById("deletegral")

          if (elemento != null) {
            elemento.innerText = 'Eliminating...'
          }



          const vrf = listvrf[Number(VRF)]
          const body = {
            vrf: vrf,
            policy: selectedItems,

          }

          if (tenant === 0) {
            axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/delete_bulk_phase_two/' + connector, body).then(res => {
              console.log(res.data.data)
              setDatos(res.data.data)
              Swal.fire(
                'Deleted!',
                'Your Policys has been deleted.',
                'success'
              );
              if (elemento != null) {
                elemento.innerText = 'Delete'
              }
              setdel(false)
            })

          }
          else if (tenant !== 0) {
            axios.post(API_URL + '/v1/VPN/instances/' + Instance + '/delete_bulk_phase_two/' + connector + '?tenantId=' + tenant, body).then(res => {
              setDatos(res.data.data)
              Swal.fire(
                'Deleted!',
                'Your Policys has been deleted.',
                'success'
              );
              if (elemento != null) {
                elemento.innerText = 'Delete'
              }
              setdel(false)
            })

          }


        }
      });

  };




  return (
    <>
      {loading && <Spinner></Spinner>}
      {del && <Spinner></Spinner>}
      <div className='card'>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column '>
            <span className='f-titulo text-marino fs-md'>View and add IPSec segments</span>

          </h3>
          {/*Se agrega Boton para agregar usuarios*/}
          {/*<Link style={{marginRight:'15px'}}to="/create" className='btn btn-primary'>Add Nex User</Link>*/}
        </div>

        <br />
        {/* end::Header */}
        <div className="d-flex flex-center">
          <div className='fv-row '>
            <div className='row '>

              <div className='col-lg-3'>
                <label className='form-label f-bold fs-p text-marino  required form-label' >Instance</label>
                <select className="form-select border-marino f-parrafo fs-p text-dk text-center w-200px" aria-label="Select example"
                  onChange={e => dispatch(SetInstance(Number(e.target.value)))} value={Instance}>
                  <option disabled selected hidden defaultValue={0}>Select an Instance </option>
                  {Instancia.length === 0 && <option disabled selected hidden>No data</option>}
                  {Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && Instancia.map((ins: any, x: any) =>
                    <option key={x} value={ins.id}>{ins.name}</option>
                  )
                  }
                  {Type === 'CloudGlobal' && Instancia.map((ins: any, x: any) =>
                    <option key={x} value={ins.id}>{ins.name}</option>
                  )
                  }
                </select>
              </div>
              <div className='w-30px'></div>

              <div className='col-lg-3'>
                <label className='form-label f-bold fs-p text-marino  required form-label' >VRF</label>
                <select className="form-select border-marino f-parrafo fs-p text-dk text-center w-200px" aria-label="Select example"
                  onChange={e => dispatch(SetvRF(Number(e.target.value)))} value={VRF}>
                  {listvrf?.length === 0 ? <option key={'x'} className='text-danger bg-info' hidden>No VRF</option> : <option hidden>Select an VRF </option>}

                  {Instance !== '' && Id !== 0 && Type !== 'CloudGlobal' && Id !== -1 && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                    <>
                      {!vrf.vrf && <option key={i} value={i}>Main</option>}
                      {vrf.vrf && <option key={i} value={i}>{vrf.vrf}</option>}
                    </>
                  )
                  }

                  {Instance !== '' && Type === 'CloudGlobal' && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                    <>
                      {!vrf.vrf && <option key={i} value={i}>Main({vrf.subscriptions})</option>}
                      {vrf.vrf && <option key={i} value={i}>{vrf.vrf}({vrf.subscriptions})</option>}
                    </>
                  )
                  }
                </select>

              </div>
              <div className='w-30px'></div>

              <div className='col-lg-3'>
                <label className='form-label f-bold fs-p text-marino  required form-label' >Connector</label>
                <select className="form-select border-marino f-parrafo fs-p text-dk text-center w-200px" aria-label="Select example"
                  onChange={e => dispatch(SetConnector(e.target.value))} value={connector}>

                  {listConnector?.length === 0 ? <option key={'c'} className='text-danger bg-info' hidden>No Connector</option> : <option hidden>Select an Connector </option>}

                  {Instance !== '' && Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && listConnector.length !== 0 && listConnector?.map((con: any, i: any) =>
                    <>
                      {con.name !== '' && <option key={i} value={con.id}>{con.name}</option>}
                    </>
                  )
                  }

                  {Instance !== '' && Type === 'CloudGlobal' && listConnector.length !== 0 && listConnector?.map((con: any, i) =>
                    <>
                      {con.name !== '' && <option key={i} value={con.id}>{con.name}</option>}

                    </>
                  )
                  }
                </select>
              </div>
              <div className='w-30px'></div>

              <div className='col-lg-1' style={{ marginTop: '13px' }}>
                <br />
                {currentUser?.ListPermiso?.includes('Ctx.IPSEC.List') && Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && <button type='submit' onClick={handleSubmit} className="btn-gradiente" style={{ width: '100px', padding: '6px' }}>{loading ? 'Searching...' : 'Search'}</button>}
                {currentUser?.ListPermiso?.includes('Ctx.IPSEC.List') && Type === 'CloudGlobal' && <button type='submit' onClick={handleSubmitGlobal} className="btn-gradiente" style={{ width: '100px', padding: '6px' }}>{loading ? 'Cargando...' : 'Search'}</button>}

              </div>


            </div>
          </div>
        </div>
        <br /><br />

        <div className="d-flex flex-wrap fw-bold  mb-4 pe-2 flex-center f-titulo fs-sub" > Add IPSec Segments</div>
        <div className='row g-5 g-xl-8'>
          <div className='col-xl-6' >
            <div className='rounded-lg border bg-card shadow-sm  border-gray-300 card h-100' style={{ marginRight: '5px', marginLeft: '20px' }} >
              <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                <div className='f-bold fs-4 mb-2 text-marino'>Add Single IPSec Segment</div>
                <div className='f-parrafo fs-p text-marino mt-auto'>Use this option to add a single IPSec segment to your configuration.</div><br />
                <div className='symbol symbol-75px mb-6'>
                  <svg viewBox="0 0 21 21" width="30"
                    height="30"
                    xmlns="http://www.w3.org/2000/svg">
                    <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" transform="translate(3 2)">
                      <path d="m6.5 3.5h-4c-1.1045695 0-2 .8954305-2 2v7c0 1.1045695.8954305 2 2 2h7c1.1045695 0 2-.8954305 2-2v-3.5-.5" /><path d="m11.5.5v6" /><path d="m11.5.5v6" transform="matrix(0 1 -1 0 15 -8)" />
                    </g>
                  </svg>
                </div>
                <div className='text-center mx-auto'>
                  <button className='btn-gradiente' style={{ padding: '6px', width: '200px' }} onClick={handleModal1Click}>Add IPSec Segment</button>
                </div>
                <Modal1 showModal={modal1Visible} handleClose={handleCloseModal1} setDatos={setDatos} />

              </div>
            </div>
          </div>
          <div className='col-xl-6'>
            <div className='rounded-lg border bg-card shadow-sm  border-gray-300 card h-100' style={{ marginLeft: '5px', marginRight: '20px' }} >
              <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                <div className='f-bold fs-4 mb-2 text-marino'>Add Multiple IPSec Segments</div>
                <div className='f-parrafo fs-p text-marino mt-auto'>Use this option to add multiple IPSec segments at once to your configuration.</div><br />
                <div className='symbol symbol-75px mb-6'>
                  <svg height="25" viewBox="0 0 21 21" width="25" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" transform="translate(4 2)"><path d="m.5 3.20588235c0-1.29949353 2.5-2.74110534 6-2.70588235s6 1.55344765 6 2.85294118v10.29411762c0 1.2994936-2.5 2.8529412-6 2.8529412s-6-1.7005065-6-3c0-.6412832 0-9.65283449 0-10.29411765z" /><path d="m.5 3.5c0 1.38071187 2 3 6 3s6-1.63689962 6-3.0176115m-12 5.0176115c0 1.38071187 2 3 6 3s6-1.63689962 6-3.0176115" /></g></svg>
                </div>
                <div className='text-center mx-auto'>
                  <button className='btn-gradiente' style={{ width: '200px', padding: '6px' }} onClick={handleModal2Click}>Add Bulk</button>
                </div>
                <Modal2 showModal={modal2Visible} handleClose={handleCloseModal2} setDatos={setDatos} />
              </div>
            </div>
          </div>
        </div>

        {Datos.length !== 0 && <div className="d-flex flex-center">
          <div className='fv-row '>
            <div className='row '>

              <div className="text-center">
                <div className="separator separator-dashed border-info opacity-25 "></div>
                <div className='f-parrafo fs-p'>
                  Total IPSec Segments: {Datos.length}
                </div>
                <div className="separator separator-dashed border-info opacity-25 "></div>
              </div>

            </div>
          </div>
        </div>}
        <br />

        {selectedItems.length !== 0 &&
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '30px' }}>
            <button
              className='btn border border-pink text-pink f-parrafo'
              onClick={deleteSelected}
              id='deletegral'
            >
              Delete selection
            </button>
          </div>}

        {/* begin::Body */}
        <div className='card-body py-3'>

          <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
              {/* begin::Table container */}

              <div className='table-responsive'>

                {/* begin::Table */}

                <div className="box-scroll">
                  <table className="w-full f-parrafo  caption-bottom  custom-table" id='table'>
                    {/* begin::Table head */}
                    <thead >
                      <tr className="table-header-light bg-marino" >
                        <th className='table-cell'>Select</th>
                        <th className='table-cell'>Local-ts Subnet</th>
                        <th className='table-cell'>Remote-ts Subnet</th>
                        <th className='table-cell'>Security Policy</th>
                        <th className='table-cell'></th>

                      </tr>
                    </thead>
                    {/* end::Table head */}


                    {/* begin::Table body */}

                    <tbody>
                      {Datos.length === 0 ? (
                        <tr>
                          <td colSpan={5} style={{ textAlign: 'center', color: 'gray', padding: '20px' }}>
                            No Data Available
                          </td>
                        </tr>
                      ) : (
                        Datos.map((d, i) => (
                          <tr key={i} className='table-row'>
                            <td className='table-cell'>
                              <input
                                type="checkbox"
                                onChange={() => toggleSelect(d.security)}
                                checked={selectedItems.includes(d.security)}
                              />
                            </td>
                            <td className='table-cell'>{d.local}</td>
                            <td className='table-cell'>{d.remote}</td>
                            <td className='table-cell'>{d.security}</td>
                            <td className='table-cell'>
                              {Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && (
                                <button className='btn-light-marino f-parrafo' id={'delete' + d.security} onClick={() => deletepolicy(d.security)}>
                                  Delete
                                </button>
                              )}
                              {Type === 'CloudGlobal' && (
                                <button className='btn-light-marino f-parrafo' id={'delete' + d.security} onClick={() => DeleteGlobal(d.security)}>
                                  Delete
                                </button>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>

                    {/* end::Table body */}

                  </table>
                </div>

                {/* end::Table */}
              </div>


            </div>
            {/* end::Tap pane */}
          </div>
        </div>
        {/* end::Body */}
      </div>
    </>

  )
}
